import { CategoryCard } from "./CategoryCard";
import apparelImage from "@/assets/apparel-category.png";
import accessoriesImage from "@/assets/accessories-preview.webp";
import heroImage from "@/assets/hero-racing.webp";

const categories = [
  {
    title: "Apparel",
    image: apparelImage,
    href: "/shop?filter=apparel",
  },
  {
    title: "Pick Your Poison",
    image: heroImage,
    href: "/shop",
    featured: true,
  },
  {
    title: "Accessories",
    image: accessoriesImage,
    href: "/shop?filter=accessories",
  },
];

export const CategoryGrid = () => {
  return (
    <section id="shop" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-center">
          {categories.map((category, index) => (
            <CategoryCard
              key={category.title}
              title={category.title}
              image={category.image}
              href={category.href}
              featured={'featured' in category ? category.featured : false}
              className={`animate-slide-up delay-${(index + 1) * 100}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
